import React from 'react';
import './ProjectPage.css';
import LinkIcon from '@material-ui/icons/Link';

const ProjectPage = ({data}) => {

  if(data) {
    var other_projects = data.other_projects.map(function(other_projects){
      return(
        <div key={other_projects.title} className="all-project-details">
          <div className="left">
            <div className ="img">
              <img className="img-pro-all" src={other_projects.image} alt="screenshot"/>
            </div>
          </div>
          <div className="right">
            <h2 className="project-title">{other_projects.title}</h2>
            <p className="project-description">{other_projects.description}</p>
            <div className="btn-allproject">
              <a className="all-link-a" href={other_projects.giturl} rel="noopener noreferrer" target="_blank"> <span className="btn-git-full"> Github Repo </span> </a>
              <a className="all-link-a" href={other_projects.livelink} rel="noopener noreferrer" target="_blank" > <span className="btn-git-full btn-live-full"> Preview <LinkIcon /> </span> </a>
            </div>
          </div>
        </div>
      )
    });
  }

    return (
      <div>
        <section className="project-section">
          <div className="container">
            <h2 className="section-title" data-outline="Projects">Projects</h2>
            <div className="all-projects">
              {other_projects}
            </div>
          </div>
        </section>
      </div>
    )
}

export default ProjectPage;
